module.exports = __webpack_public_path__ + "media/images/emblems/Utzenstorf-coat_of_arms-d1a5708223c5d48dfbb9908732dac2bf.svg";